import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { MathUtils } from '@/domain/utils/mathUtils';
import { qaAttr } from '@/presentation/utils/qaAttr';
import {
  ExpauseButton,
} from '@/presentation/components/common/controls/ExpauseButton';

/**
 * The "{usd} USD raised" + "Show support" donation block of a roadmap card.
 *
 * Ports `roadmap_list_item.dart:191-242`: the raised-amount line and the
 * outlined "Show support" CTA. Per the story's deferred-actions rule the tap
 * surfaces the not-implemented sheet via the parent's `onShowSupport` handler.
 */
interface RoadmapItemSupportBlockProps {
  itemId: string;
  usd: number;
  onShowSupport: () => void;
}

export const RoadmapItemSupportBlock: React.FC<RoadmapItemSupportBlockProps> = ({
  itemId,
  usd,
  onShowSupport,
}) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const { l10n } = useLocale();

  return (
    <div
      onClick={onShowSupport}
      {...qaAttr({ id: `roadmap-item-support-${itemId}` })}
      style={{
        marginTop: responsive.spacing['3xl'],
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <span
        style={{
          marginBottom: responsive.spacing.xxs,
          textAlign: 'center',
          color: theme.text.primary,
          fontSize: responsive.font.base,
        }}
      >
        {l10n.roadmap.usdRaised.replace(
          '{value}',
          MathUtils.getReactionsIntlNumber(usd),
        )}
      </span>
      <ExpauseButton
      >
        {l10n.roadmap.showSupport}
      </ExpauseButton>
    </div>
  );
};
